import { MarkerClusterer } from "../../node_modules/@googlemaps/markerclusterer";

document.addEventListener("alpine:init", () => {
    Alpine.data("map", (mapId, updateZoom = false, infoWindow = true) => ({
        map: null,
        markers: [],
        infoWindow: null,
        markerClusterer: null,
        locations: [],
        bounds: null,
        mapLoad: true,
        view: "map",
        toggleWidth: 0,
        init() {
            this.getAllLocations();

            if (this.locations.length > 0) {
                setTimeout(() => {
                    this.refreshMap();
                }, 100);
            } else {
                throw new Error("No locations found");
            }

            this.mapLoad = true;

            window.mapComponent = this;
        },

        refreshMap(idle = true) {
            this.bounds = new google.maps.LatLngBounds();

            this.initMap().then((map) => {
                this.setAllMarkers(map)
                    .then((markers) => {
                        markers.forEach((marker) => {
                            this.bounds.extend(marker.position);
                        });

                        map.fitBounds(this.bounds);

                        map.addListener("zoom_changed", function () {
                            if (map.getZoom() > 17) {
                                map.setZoom(17);
                            }
                        });
                    })
                    .then(() => {
                        // if (!idle) {
                        //     return;
                        // }

                        // let idleListener = map.addListener("idle", (e) => {
                        //     const bounds = map.getBounds();

                        //     if (!this.mapLoad) {
                        //         window.dispatchEvent(
                        //             new CustomEvent("map-locations-updated", {
                        //                 detail: {
                        //                     locations:
                        //                         JSON.stringify(bounds),
                        //                 },
                        //             })
                        //         );
                        //     }

                        //     this.mapLoad = false;

                        // });

                        this.updateTypeToggle();
                    })
                    .then(() => {
                        this.map = map;
                        if (updateZoom || this.locations.length <= 5) {
                            map.setZoom(17);
                        }
                        setTimeout(() => {
                            window.dispatchEvent(new Event("resize"));
                        }, 500);
                    });
            });
        },

        updateMarkers() {
            this.locations = [];
            this.getAllLocations();

            if (this.locations.length > 0) {
                this.refreshMap(false);
            } else {
                throw new Error("No locations found");
            }
        },

        initMap() {
            return new Promise(async (resolve, reject) => {
                const { Map } = await google.maps.importLibrary("maps");

                const map = new Map(document.getElementById("map"), {
                    center: { lat: 51.5072, lng: 0 },
                    zoom: 7,
                    mapId: mapId,
                    disableDefaultUI: true,
                });

                if (infoWindow) {
                    this.infoWindow = new google.maps.InfoWindow({
                        content: "",
                    });
                }

                resolve(map);
            });
        },

        getAllLocations() {
            const locationsGrid = document.querySelector(
                "[data-map-locations]"
            );

            const locations = JSON.parse(locationsGrid.dataset.mapLocations);

            locations.forEach((location) => {
                if (
                    typeof location.lat === "undefined" ||
                    typeof location.lng === "undefined" ||
                    location.lat === "" ||
                    location.lng === "" ||
                    isNaN(parseFloat(location.lat)) ||
                    isNaN(parseFloat(location.lng))
                ) {
                    return;
                }

                // // Some of the lats and lngs have a strange comma appearing in them, this is a quick fix to remove them
                // location.lat = parseFloat(location.lat.replace(',', ''));
                // location.lng = parseFloat(location.lng.replace(',', ''));

                this.locations.push({
                    lat: parseFloat(location.lat),
                    lng: parseFloat(location.lng),
                    img: location.img,
                    title: location.title,
                    link: location.link,
                    address: location.address,
                    poi: location.poi,
                    networkOnly: location.networkOnly,
                });
            });
        },

        setAllMarkers(map) {
            return new Promise(async (resolve, reject) => {
                const { AdvancedMarkerElement } =
                    await google.maps.importLibrary("marker");

                this.markers = this.locations.map((location) => {
                    const parser = new DOMParser();
                    let pinSvgString =
                        '<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" style="max-height:27px; max-width:27px;"><rect width="27" height="27" rx="13.5" fill="black" /><rect x="9" y="9" width="9" height="9" rx="4.5" fill="#6886c5"/></svg>';

                    if (location.poi) {
                        pinSvgString = `
                            <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.5" width="37" height="37" rx="18.5" fill="black"/>
                            <rect x="0.5" y="0.5" width="37" height="37" rx="18.5" stroke="#000"/>
                            <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="14" font-weight="600" fill="#6886c5">${location.poi}</text>
                            </svg>`;
                    }

                    const pinSvg = parser.parseFromString(
                        pinSvgString,
                        "image/svg+xml"
                    ).documentElement;

                    let markerObject = {
                        position: new google.maps.LatLng(
                            location.lat,
                            location.lng
                        ),
                        map: map,
                        content: pinSvg,
                    };

                    const marker = new AdvancedMarkerElement(markerObject);

                    if (infoWindow) {
                        marker.addListener("click", () => {
                            this.infoWindow.setContent(
                                this.createInfoWindowContent(location)
                            );
                            this.infoWindow.open(map, marker);
                        });
                    }

                    return marker;
                });

                const svg = window.btoa(`
                    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="37" height="37" rx="18.5" fill="#000"/>
                    <rect x="0.5" y="0.5" width="37" height="37" rx="18.5" stroke="#000"/>
                    </svg>`);

                const renderer = {
                    render: ({ count, position }) =>
                        new google.maps.Marker({
                            label: {
                                text: String(count),
                                color: "#6886c5",
                                fontSize: "14px",
                                fontWeight: "600",
                            },
                            icon: {
                                url: `data:image/svg+xml;base64,${svg}`,
                                scaledSize: new google.maps.Size(38, 38),
                            },
                            position,

                            zIndex:
                                Number(google.maps.Marker.MAX_ZINDEX) + count,
                        }),
                };

                this.markerCluster = new MarkerClusterer({
                    map,
                    markers: this.markers,
                    renderer,
                });

                resolve(this.markers);
            });
        },

        createInfoWindowContent(location) {
            let content =
                '<div class="text-content-dark ' +
                (location.poi || !location.img ? "pt-2.5 pb-5" : "") +
                '">';
            let img =
                '<img src="' +
                location.img +
                '" alt="' +
                location.title +
                '" class="w-full h-auto mb-4">';
            let title = "";
            let address = "";
            let mapLink = !location.networkOnly
                ? '<p><a href="' +
                  location.link +
                  '" target="_blank" class="text-black js-map-link"><span class="sr-only">Find out more</span><svg width="24" height="24" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1456_16328)"><path d="M3 8.5H13.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 4L14 8.5L9.5 13" stroke="currentColor" stroke-linecap="round"/></g></svg></a></p>'
                : "";

            if (location.title) {
                title +=
                    '<span class="heading-six">' + location.title + "</span>";
            }

            if (location.address) {
                address +=
                    '<p class="map-tile-address body-base text-greyscale-grey-02 max-w-[200px]">' +
                    location.address +
                    "</p>";
            }

            content +=
                (!location.poi ? img : "") +
                title +
                address +
                mapLink +
                "</div>";

            return content;
        },

        updateTypeToggle(updateView = false) {
            if (updateView) {
                if (this.view === "map") {
                    this.view = "satellite";
                    this.map.setMapTypeId("satellite");
                } else {
                    this.view = "map";
                    this.map.setMapTypeId("roadmap");
                }
            }

            const toggle = this.$root.querySelector(".map-type-controls");
            const map = toggle.querySelector(".map-label");
            const satellite = toggle.querySelector(".satellite-label");

            if (this.view === "map") {
                this.toggleWidth = map.offsetWidth;
            } else {
                this.toggleWidth = satellite.offsetWidth;
            }
        },
    }));
});
